export const DELETE_COMMENT_REQUEST = 'comment/DELETE_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'comment/DELETE_SUCCESS';
export const DELETE_COMMENT_FAILURE = 'comment/DELETE_FAILURE';
